import type { FaireProductEntity } from "../../entity_types/product";

export const p_9qkevsgedt: FaireProductEntity = {
  token: "p_9qkevsgedt",
  type: "product",
  name: "New To The Club Patch Short Sleeve Romper - Baby Clothes",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/42e3e510d27c59a27a6d791b747783d0b87c0ae4a665cb575932b525e029fd3e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/64c683f1b45ca42fcc24670930e49764725d950d1568ea7c36582fb11073fa72.jpeg",
    "https://cdn.faire.com/fastly/baaa6226730218a5724928098e327f566709aa8b2999aeaf80ecc4b919669f34.jpeg",
    "https://cdn.faire.com/fastly/f969b39025de5b91a10275b20f574a674bb7a390fef53abfecbb2121ef7845ef.jpeg",
  ],
  priceDollars: 18,
  description:
    "Welcome the newest member of your foursome with this romper that brings championship flair and country club style to his very first fairway-ready look.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Romper Color: White\n• Patch Color: Green and red\n• Material: 100% Cotton\n• Features: Tagless inside neck label for an itch-free wear; 3 snap closure; cuffed sleeves; trendy bubble style\n• Fit: Infant Unisex\n• Care: Machine washable, wash inside out, lay flat to dry\n\nEach romper is hand pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:24.239Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
